import { FieldViewModel } from "../../fields"
import { SharedFieldsService } from "../../fields/service"

/** @internal */
export class EventInfoService {


    private fields: Map<number, FieldViewModel> = new Map()
    private cropping: Map<number, FieldViewModel> = new Map()

    static $inject = ["OmniaFieldsService"]

    constructor(
        private readonly fieldSvc: SharedFieldsService
    ) {

    }

    ensureInitialized(): PromiseLike<any> {

        return this.fieldSvc.refresh().then(() => this.setup())

    }

    private setup() {
        this.fields = new Map(this.fieldSvc.fields.map(f => [f.fieldId, f]))
        this.cropping = new Map(this.fieldSvc.cropping.map(c => [c.croppingId, c]))
    }

    getField(fieldId: number) {
        return this.fields.get(fieldId)
    }

    getFieldDescription(fieldId: number) {
        return this.fields.get(fieldId)?.description
    }

    getCropping(croppingId: number) {
        return this.cropping.get(croppingId)
    }

    getCroppingDescription(croppingId: number) {
        return this.cropping.get(croppingId)?.description
    }

}
